import client from './client';

const Cases = {
  getCases(anketId) {
    return client.get(`/ankets/${anketId}/kf_analytics/cases`);
  },
  getCase(anketId, caseNumber) {
    return client.get(`/ankets/${anketId}/kf_analytics/cases/${caseNumber}`);
  },
};

export default Cases;
